// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_RecalcularSnapshotInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /planoscontas/snapshot/{fechamento_id}/recalcular
 *
 * Recalculates valor_realizado for a snapshot. No body required —
 * fechamento_id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Planoscontas_RecalcularSnapshotInput {}

registerContract('Planoscontas_RecalcularSnapshotInput', {})
